import { ChangeDetectorRef, Component, EventEmitter, Input, Output } from '@angular/core';
import { OrderEntry } from '@spartacus/core';
import { UserAccountFacade } from '@spartacus/user/account/root';
import { ProductService } from '../../product/service/product.service';

@Component({
  selector: 'cx-wish-list-item',
  templateUrl: './wish-list-item.component.html',
  styleUrls: ['./wish-list-item.component.scss'],
})
export class WishListItemComponent {

  @Input()
  isLoading = false;
  @Input() cartEntry: any | undefined;
  @Input() userId: any;
  @Output()
  removeItem = new EventEmitter<OrderEntry>();

  constructor(
    protected productService: ProductService,
    protected userAccount: UserAccountFacade,
    private cd: ChangeDetectorRef
  ) { }



  removeEntry(item: any) {
    this.removeItem.emit(item);
  }
}
